import React from 'react'; // TODO
// eslint-disable-next-line @typescript-eslint/interface-name-prefix

var TabContext = React.createContext(null);
export default TabContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/esm/TabContext.js
// module id = 100
// module chunks = 0